module.exports = __webpack_public_path__ + "static/media/logoPrincipal.7da3e432.png";